import { FC } from 'react';
import { Button, Flex } from 'antd';
import { Modal, ModalFooter, Padding } from '..';
import translations from './NavigateAwayModal.translations.json';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import * as Icon from 'react-feather';
import { colorWarning } from '@atlas-frontend/design-tokens';

const { addTranslations, t } = i18nNsFactory('algorithms-table');
addTranslations(translations);

export const NavigateAwayModal: FC<{
  onOk: () => void;
  onCancel: () => void;
}> = ({ onOk, onCancel }) => (
  <Modal
    footer={
      <ModalFooter>
        <Flex gap="small" justify="end">
          <Button id="navigate-away-cancel" type="default" onClick={onCancel}>
            {t('cancelText')}
          </Button>
          <Button id="navigate-away-ok" type="default" onClick={onOk}>
            {t('okText')}
          </Button>
        </Flex>
      </ModalFooter>
    }
  >
    <Padding scrollable>
      <Flex justify="center" align="center" vertical gap="middle">
        <Icon.AlertTriangle size={80} color={colorWarning} />
        <div>
          <h3>{t('title')}</h3>
          <p>{t('content')}</p>
        </div>
      </Flex>
    </Padding>
  </Modal>
);
